module.exports = __webpack_public_path__ + "media/eater-type/eats-anything-7b7e5904.svg";